'use strict';

var zh = {
  LOADING: '数据载入中...',
  FAIL_TO_LOAD: '抱歉，加载数据失败。',
  REMOTE_1: '错误：不能直接在本地打开此页面, 如果你需要在本地预览, 请',
  REMOTE_2: '查看 ',
  REMOTE_3: '。',
  REMOTE_4: '如需帮助请查看',
  ALWAYS_SHOW_LINK: '始终显示链接',
  HOVER_SHOW_LINK: '鼠标滑过时，显示链接',
  HOVER_SHOW_REMARK: '鼠标滑过时，显示备注',
  SHOW_REMARKS: '显示批注',
  SETTINGS: '控制面板',
  HOME: '首页',
  PREV: '上一页',
  NEXT: '下一页',
  PLAYBACK: '回放',
  QRCODE: '扫描二维码，在手机中查看',
  ERROR: '错误：',
  HELP: '如需帮助， 请加入 QQ 群： 535479281 或者发邮件至 service@jongde.com。',
  INSTALL: '安装此应用',
  CLICK_DOWN: '请点击屏幕下方的',
  ADD_HOME: '选择“添加到主屏幕”',
  CLICK_MENU: '请点击屏幕右上角菜单',
  SKIP_INSTALL: '安装后可以获得最佳体验。暂时不想安装？',
  OPEN_NOW: '直接打开',
  OPEN_IN_SAFARI: '选择“在Safari中打开”',
  SITE_MAP_ERROR : '哦嗬，出错了！\n\u00a0\n站点地图的节点配置不正确，你应该像这样配置：\n\u00a0\n首页\n-公司\n-产品...',
  NOT_AVAILABLE_ON_MOBILE: '不支持在移动设备上查看此项目。'
};

var en = {
  LOADING: 'Loading...',
  FAIL_TO_LOAD: 'Sorry, failed to load data.',
  REMOTE_1: 'Error: This page cannot be opened directly from local. If you would like to preview it offline, please ',
  REMOTE_2: 'view ',
  REMOTE_3: '.',
  REMOTE_4: 'Read this for help',
  ALWAYS_SHOW_LINK: 'Always show link',
  HOVER_SHOW_LINK: 'Show link when mouse over',
  HOVER_SHOW_REMARK: 'Show remark when mouse over',
  SHOW_REMARKS: 'Show markup',
  SETTINGS: 'Control panel',
  HOME: 'Home',
  PREV: 'Back',
  NEXT: 'Forward',
  PLAYBACK: 'Playback',
  QRCODE: 'Scan QR code to view on mobile',
  ERROR: 'Error:',
  HELP: 'If you need assistance, please shoot us an email at support@jongde.com.',
  INSTALL: 'Install This Prototype',
  CLICK_DOWN: 'Tap the below share button',
  ADD_HOME: 'Then choose “Add to Home Screen”',
  CLICK_MENU: 'Tap the menu at the upper right corner',
  SKIP_INSTALL: 'Install now to get the best experience. Install later?',
  OPEN_NOW: 'Open directly',
  OPEN_IN_SAFARI: 'Then choose “Open in Safari”',
  SITE_MAP_ERROR : 'Errors!\n\u00a0\nNodes configured for site map are false and you should configure therm as follows:\n\u00a0\nHome\n-Company\n-Product...',
  NOT_AVAILABLE_ON_MOBILE: 'This project cannot be viewed on mobile device.'
};

var lang = window.en ? en : zh;

exports.get = function (n) {
  return lang[n];
};


/** WEBPACK FOOTER **
 ** ./src/helper/i18n.js
 **/